import { render, staticRenderFns } from "./ServePage.vue?vue&type=template&id=52eeab10&scoped=true"
import script from "./ServePage.vue?vue&type=script&lang=js"
export * from "./ServePage.vue?vue&type=script&lang=js"
import style0 from "./ServePage.vue?vue&type=style&index=0&id=52eeab10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eeab10",
  null
  
)

export default component.exports